module.exports = __webpack_public_path__ + "img/card-bkgd.5e8b7009.png";